/* global bootstrap */
(function (Drupal) {
  Drupal.behaviors.halifax_tooltips = {
    attach() {
      //  initialize all tooltips
      const tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );
      tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
      });
    },
  };
})(Drupal);
